import { MS_PER_SECOND, SECONDS_PER_MINUTE } from '../../features/shared/time-units'

const OFFER_DURATION_MINUTES = 28

export const DURATION_MS = OFFER_DURATION_MINUTES * SECONDS_PER_MINUTE * MS_PER_SECOND

/** Formats a millisecond duration as zero-padded MM:SS, truncating the sub-second remainder. */
export function formatTime(ms: number): string {
  const totalSeconds = Math.floor(ms / MS_PER_SECOND)
  const minutes = Math.floor(totalSeconds / SECONDS_PER_MINUTE)
  const seconds = totalSeconds % SECONDS_PER_MINUTE
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
}

/** Reads the offer deadline stored under `key`, persisting a new one when it is absent or invalid;
 * when localStorage throws, the deadline lives in memory only. */
export function getOrCreateDeadline(key: string): number {
  try {
    const stored = localStorage.getItem(key)
    if (stored !== null) {
      const parsed = Number(stored)
      if (Number.isFinite(parsed) && parsed > 0) {
        return parsed
      }
    }
    const deadline = Date.now() + DURATION_MS
    localStorage.setItem(key, String(deadline))
    return deadline
  } catch {
    return Date.now() + DURATION_MS
  }
}
